import { render, staticRenderFns } from "./Contactos.vue?vue&type=template&id=2a2b0d5d&"
import script from "./Contactos.vue?vue&type=script&lang=ts&"
export * from "./Contactos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a2b0d5d', component.options)
    } else {
      api.reload('2a2b0d5d', component.options)
    }
    module.hot.accept("./Contactos.vue?vue&type=template&id=2a2b0d5d&", function () {
      api.rerender('2a2b0d5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Contactos/Contactos.vue"
export default component.exports